module.exports = __webpack_public_path__ + "img/view3d-notice-dhfx1.9deb90f4.png";